import { Box, Button, Stack, Typography } from "@mui/material";
import MappingFieldCard from "./MappingFieldCard";
import { FIELD_LIST_MAX_HEIGHT } from "./mappingConstants";

/** The right-hand panel: add-field action, the scrollable field list, and a hint for the
 * currently-selected field. Pure presentation. All state lives in MappingPage. */
const MappingFieldList = ({
  fields,
  selectedIndex,
  canEdit,
  prefillGroups,
  onSelect,
  onUpdate,
  onPrefillChange,
  onDelete,
  onAdd,
}) => {
  const selected = selectedIndex === null ? null : fields[selectedIndex] || null;

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="subtitle1">Fields ({fields.length})</Typography>
        {canEdit && <Button onClick={onAdd}>Add field</Button>}
      </Stack>

      <Box sx={{ maxHeight: FIELD_LIST_MAX_HEIGHT, overflow: "auto", mt: 1 }}>
        {fields.map((field, index) => (
          <MappingFieldCard
            key={index}
            field={field}
            isSelected={index === selectedIndex}
            canEdit={canEdit}
            prefillGroups={prefillGroups}
            onSelect={() => onSelect(index)}
            onUpdate={(changes) => onUpdate(index, changes)}
            onPrefillChange={(prefillKey) => onPrefillChange(index, prefillKey)}
            onDelete={() => onDelete(index)}
          />
        ))}
        {fields.length === 0 && (
          <Typography variant="body2" color="text.secondary">
            No fields yet. Add one, then draw its box on the page.
          </Typography>
        )}
      </Box>

      {selected && (
        <Typography variant="caption" color="text.secondary">
          Selected: {selected.label}. Draw on the page to place it.
        </Typography>
      )}
    </Box>
  );
};

export default MappingFieldList;
